export const en = {
    'interest-type-all': 'for any period',
    'interest-type-long-term': 'long-term',
    'interest-type-short-term': 'short-term',
    interests: 'Interests'
};
